export function emojiPicker() {
    $(document).ready(function () {
        const targetDiv = $('.g-chatform-emojipicker-content');

        if (!targetDiv.length) {
            return;
        }

        let pickerPromise = null;

        function loadEmojiMart() {
            if (window.EmojiMart && window.EmojiMart.Picker) {
                return Promise.resolve(window.EmojiMart);
            }

            if (window._growtypeChatEmojiMartPromise) {
                return window._growtypeChatEmojiMartPromise;
            }

            const pluginUrl = window.growtype_chat_ajax && window.growtype_chat_ajax.plugin_url;
            const scriptUrl = window.growtype_chat_ajax && window.growtype_chat_ajax.emoji_mart_url
                ? window.growtype_chat_ajax.emoji_mart_url
                : (pluginUrl ? `${pluginUrl}libs/emoji-mart/index.js` : '');

            window._growtypeChatEmojiMartPromise = new Promise(function (resolve, reject) {
                if (!scriptUrl) {
                    reject(new Error('Emoji picker script URL is unavailable.'));
                    return;
                }

                const existing = document.querySelector('script[data-growtype-chat-emoji-mart]');
                if (existing) {
                    existing.addEventListener('load', function () { resolve(window.EmojiMart); }, {once: true});
                    existing.addEventListener('error', reject, {once: true});
                    return;
                }

                const script = document.createElement('script');
                script.src = scriptUrl;
                script.async = true;
                script.dataset.growtypeChatEmojiMart = '1';
                script.addEventListener('load', function () {
                    if (window.EmojiMart && window.EmojiMart.Picker) {
                        resolve(window.EmojiMart);
                    } else {
                        reject(new Error('Emoji picker script loaded without exposing EmojiMart.'));
                    }
                }, {once: true});
                script.addEventListener('error', reject, {once: true});
                document.head.appendChild(script);
            }).catch(function (error) {
                window._growtypeChatEmojiMartPromise = null;
                throw error;
            });

            return window._growtypeChatEmojiMartPromise;
        }

        function initializePicker() {
            if (pickerPromise) {
                return pickerPromise;
            }

            targetDiv.addClass('is-loading');
            pickerPromise = Promise.all([
                loadEmojiMart(),
                fetch('https://cdn.jsdelivr.net/npm/@emoji-mart/data@1.2.1/sets/15/native.json')
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Emoji data request failed with status ' + response.status);
                }

                return response.json();
            })
            ]).then(function (results) {
                const EmojiMart = results[0];
                const emojiData = results[1];
                const picker = new EmojiMart.Picker({
                    data: emojiData,
                    set: 'native',
                    theme: 'dark',
                    icons: 'auto',
                    emojiVersion: '15.0',
                    locale: 'en',
                    autoFocus: false,
                    navPosition: 'top',
                    previewPosition: 'none',
                    searchPosition: 'sticky',
                    onEmojiSelect: function (emoji) {
                        const inputField = targetDiv.closest('.g-chatform').find('.g-chatform-text-input');
                        inputField.val(inputField.val() + (emoji.native || `:${emoji.id}:`));
                    }
                });

                targetDiv.append(picker);
                targetDiv.removeClass('is-loading');
                return picker;
            })
            .catch(function (error) {
                pickerPromise = null;
                targetDiv.removeClass('is-loading');
                targetDiv.addClass('emoji-picker-unavailable');
                targetDiv.closest('.g-chatform-emojipicker')
                    .find('.g-chatform-emojipicker-trigger')
                    .hide();
                throw error;
            });

            return pickerPromise;
        }

        targetDiv.closest('.g-chatform-emojipicker').find('.g-chatform-emojipicker-trigger').click(function () {
            let content = $(this).closest('.g-chatform-emojipicker').find('.g-chatform-emojipicker-content');

            if (!content.is(':visible')) {
                content.fadeIn();
                $(this).closest('.g-chatform-emojipicker').addClass('is-active');
                initializePicker().catch(function () {});
            } else {
                content.fadeOut();
                $(this).closest('.g-chatform-emojipicker').removeClass('is-active');
            }
        });

        $('body').click(function (e) {
            if (!$(e.target).closest('.g-chatform-emojipicker').length) {
                $('.g-chatform-emojipicker-content').fadeOut();
                $('.g-chatform-emojipicker').removeClass('is-active');
            }
        });
    });
}
